module.exports = __webpack_public_path__ + "static/media/Central-web.0ef665c7.jpg";